import * as types from '../constants/ActionTypes';
import { store } from '..';

const todoForApi = myTodo => ({
	message: myTodo.text,
	status: myTodo.completed ? 'COMPLETED' : 'ACTIVE'
});
export const addTodo = todo => ({ type: types.ADD_TODO, todo });

export const setTodos = todos => ({ type: types.SET_TODOS, todos });

export const setFilteredTodos = todos => ({
	type: types.SET_FILTERED_TODOS,
	todos
});
export const deleteTodo = id => ({ type: types.DELETE_TODO, id });
export const editTodo = (id, text) => ({ type: types.EDIT_TODO, id, text });
export const completeTodo = id => ({ type: types.COMPLETE_TODO, id });
export const completeAllTodos = () => ({ type: types.COMPLETE_ALL_TODOS });
export const clearCompleted = () => ({ type: types.CLEAR_COMPLETED });
export const setVisibilityFilter = filter => {
	const filterForApi = filter =>
		({
			show_all: '',
			show_completed: 'COMPLETED',
			show_active: 'ACTIVE'
		}[filter]);

	console.log(filter);
	console.log(filterForApi(filter));
	fetch('https://546fmypedf.execute-api.us-east-2.amazonaws.com/1/todoFilter', {
		method: 'POST',
		body: JSON.stringify({
			todos: store.getState().todos.allTodos.map(todoForApi),
			filter: filterForApi(filter)
		})
	})
		.then(a => a.json())
		.then(filteredTodos => store.dispatch(setFilteredTodos(filteredTodos)));

	return {
		type: types.SET_VISIBILITY_FILTER,
		filter
	};
};



// WEBPACK FOOTER //
// ./src/actions/index.js